module.exports = __webpack_public_path__ + "img/exam_jan_2025_by5njsfi.4b579151.jpg";